import React, { PureComponent } from "react";
import { get } from "lodash";

import { withFilterCars } from "./../../shared/containers/containerFilterCars";
import { withAppState } from "./../../shared/containers/containerAppState";

import ButtonMediumDefault from "./../../shared/items/contols/buttonMediumDefault";
import ButtonMediumDefaultPrevIcon from "./../../shared/items/contols/buttonMediumDefaultPrevIcon";
import FilterCarsTooltip from "./../../shared/filterCarsTooltip";
import Icon from "./../../shared/items/static/icon";
import TooltipWrapper from "./../../shared/items/contols/tooltipWrapper";

import styles from "./sideBar.module.scss";

class SideBar extends PureComponent {
  componentDidMount() {
    const { isCarsSecondSideBarOpen, onCloseCarsSecondSideBar } = this.props;

    if (isCarsSecondSideBarOpen) onCloseCarsSecondSideBar();
  }

  handleSideBarClose() {
    const {
      isCarsSecondSideBarOpen,
      isDriversSecondBarOpen,
      onCloseSideBarAction,
      onCloseCarsSecondSideBar,
      onCloseDriversSecondSideBar,
    } = this.props;

    onCloseSideBarAction();
    if (isCarsSecondSideBarOpen) onCloseCarsSecondSideBar();

    if (isDriversSecondBarOpen) onCloseDriversSecondSideBar();
  }

  render() {
    const {
      isSideBarOpen,
      onOpenSideBarAction,
      TitleClosed,
      onHandleChangeStore,
      isCarsSecondSideBarOpen,
      onOpenCarsSecondSideBar,
      onCloseCarsSecondSideBar,
      filterCarsListItems,
    } = this.props;

    return (
      <div className={isSideBarOpen ? styles.sideBar_open : styles.sideBar_closed}>
        <button
          className={isSideBarOpen ? styles.buttonToggleOpen_barOpen : styles.buttonToggleOpen_barClosed}
          onClick={isSideBarOpen ? this.handleSideBarClose.bind(this) : onOpenSideBarAction}
        >
          <TooltipWrapper title={isSideBarOpen ? "Свернуть панель" : "Развернуть панель"} position="right">
            <div className={styles.container_sideBarIcon}>
              <Icon name="forward" />
            </div>
          </TooltipWrapper>
        </button>
        <div className={styles.container_title}>
          <div className={styles.container_controls}>
            <TooltipWrapper
              title={`${get(filterCarsListItems, ["isBookmark"], false) ? "Показать все" : "Показать Избранные"}`}
              position="right"
            >
              <div>
                <ButtonMediumDefault
                  className={get(filterCarsListItems, ["isBookmark"], false) ? "active" : ""}
                  handleClick={onHandleChangeStore.bind(this, "isBookmark", !get(filterCarsListItems, ["isBookmark"], false))}
                >
                  <ButtonMediumDefaultPrevIcon>
                    <Icon name="fav" />
                  </ButtonMediumDefaultPrevIcon>
                </ButtonMediumDefault>
              </div>
            </TooltipWrapper>

            <FilterCarsTooltip>
              <ButtonMediumDefault
                className={isCarsSecondSideBarOpen ? "active" : ""}
                handleClick={isCarsSecondSideBarOpen ? onCloseCarsSecondSideBar : onOpenCarsSecondSideBar}
              >
                <ButtonMediumDefaultPrevIcon>
                  <Icon name="filter" />
                </ButtonMediumDefaultPrevIcon>
              </ButtonMediumDefault>
            </FilterCarsTooltip>
          </div>

          {TitleClosed}
        </div>
        <div className={styles.container_sideBarInner}>{this.props.children}</div>
      </div>
    );
  }
}

export default withAppState(withFilterCars(SideBar));
